import React from 'react';
import { Icon } from '@iconify/react';
import { HotelRoomState } from '../../../types/zitoneoServicesTypes';
import useTranslate from '../../../../../customHooks/useTranslate';
import Gallery from './gallery/Gallery';
import Tooltip from '../../../../../muiComponents/Tooltip';

const RoomTypeGallery = ({ room }: { room: HotelRoomState }) => {
    const translate = useTranslate();
    const titleId = `room-type-gallery-title-${
        room.MasterRoomName
    }-${Math.random().toString(36).substr(2, 9)}`;
    const galleryItems = room.HotelImages.map(image => ({
        src: image.Url,
        alt: image.Caption,
    }));

    return (
        <Gallery
            titleId={titleId}
            title={
                <Tooltip
                    hideTooltip={!room.SupplierHotelRooms.length}
                    title={
                        <ul>
                            {room.SupplierHotelRooms.map(supplierRoom => (
                                <li key={supplierRoom.SupplierHotelRoom}>
                                    <span className='font-weight-b text-secondary-color'>{`(${supplierRoom.MappingCode})`}</span>
                                    {' - '} {supplierRoom.SupplierHotelRoom}
                                </li>
                            ))}
                        </ul>
                    }
                >
                    <h3 className='service-content-item__title'>
                        <Icon
                            icon='icon-park-outline:dot'
                            className='service-content-item__icon'
                            aria-hidden='true'
                        />
                        {room.MasterRoomName}
                    </h3>
                </Tooltip>
            }
            subtitle={
                room.HotelImages.length
                    ? `${room.HotelImages.length} ${
                          room.HotelImages.length === 1
                              ? translate('photo')
                              : translate('photos')
                      }`
                    : ''
            }
            items={galleryItems}
            showMoreLabel={translate('show_more_photos')}
        />
    );
};

export default RoomTypeGallery;
